import * as actionTypes from '../actions/ActionTypes'

export default function(state = [], action) {
  switch (action.type) {
    case actionTypes.LISTS_CALL_IN_TYPE_SUB_1_UPDATE:
      return action.listsCallInTypeSub1
    default:
      return state
  }
}